import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export enum PageStep {
  CHECK_PLANS = 'checkplans',
  TV_PLAN = 'tvplan',
  HOME_PHONE_PLAN = 'homephoneplan',
  CONTACT_INFORMATION = 'contactinformation',
  CHECKOUT = 'checkoout',
}

export function defaultFormData() {
  return {
    isUpdateCart: 1,
    formData: 0,
    shipping_address: {
      Line1: '',
      SubBuilding: '',
      City: '',
      Province: '',
      PostalCode: '',
      Lat: 0.0,
      Lng: 0.0,
    } as {
      Line1: string
      SubBuilding: string
      City: string
      Province: string
      PostalCode: string
      Lat?: number
      Lng?: number
      BuildingNumber?: string
      CountryIso2?: string
      Country?: string
      Street?: string
    },
    mailing_address: {
      Line1: '',
      SubBuilding: '',
      City: '',
      Province: '',
      PostalCode: '',
      Lat: 0.0,
      Lng: 0.0,
    } as {
      Line1: string
      SubBuilding: string
      City: string
      Province: string
      PostalCode: string
      Lat?: number
      Lng?: number
      BuildingNumber?: string
      CountryIso2?: string
      Country?: string
      Street?: string
    },
    plan_id: null as number | null,
    addons: [] as string[],
    optional_addons: [] as string[],
    Service_Area: '',
    tv_plan: null as number | null,
    // Optional-plan arrays carry CatalogTvAddon.id (number); stttp uses
    // api_name strings in some code paths and numeric ids in others, so the
    // union reflects the current mixed usage.
    tv_optional_plans: [] as number[],
    tv_optional_single_plans: [] as number[],
    tv_optional_single_plans_name: [] as string[],
    tv_sttp_plans: [] as Array<string | number>,
    selectedAddonPlanData: [] as Array<{ id: string }>,
    is_mailing: true,
    is_new_phone: true,
    is_existing_phone: false,
    is_business: false,
    customer: {
      first_name: '',
      last_name: '',
      port_number: '',
      phone: '',
      losing_carrier: '',
      email: '',
      cf_suggested_turn_on_date: '',
      cf_company_name: '',
    },
    fibreAppointment: {
      startTime: '',
      endTime: '',
      quota: '',
      workTypeId: '',
    },
    total: 0,
    SA_SFRecordID: '',
    monthly_yearly: 'M',
    monthEstimate: null as IEstimate | null,
    yearEstimate: null as IEstimate | null,
    optionalPlanTrigger: 0,
    OptionalPagePlan: [] as CatalogTvAddon[],
    OptionalPagePlansIcons: [] as CatalogTvChannel[],
    OptionalPagePlansIconsName: [] as string[],
    optionaPlansIcons: [] as string[],
    hideTvPlan: '',
    selectedItems: {
      internet: true,
      tv: false,
      home_phone: false,
      mobile: false,
    },
    // Frontend only field
    page: PageStep.CHECK_PLANS,
    addressType: '' as '' | 'PurpleCow' | 'Eastlink',
  }
}

type FormState = ReturnType<typeof defaultFormData> & {
  page: PageStep
  internet_tv_total?: number
}
const formSlice = createSlice({
  name: 'form',
  initialState: defaultFormData() as FormState,
  reducers: {
    setFormData(state, action: PayloadAction<Partial<FormState>>) {
      return { ...state, ...action.payload }
    },
    updateCustomer(
      state,
      action: PayloadAction<Partial<FormState['customer']>>
    ) {
      state.customer = { ...state.customer, ...action.payload }
    },
    resetFormData() {
      return defaultFormData()
    },
  },
})

export const { setFormData, updateCustomer, resetFormData } = formSlice.actions
export default formSlice.reducer
